module.exports = __webpack_public_path__ + "img/HZ-G1550.ffd53308.jpg";